export default function (element: Element | string): void {
  let refEl: Element | string | null = element

  if (typeof element === 'string') {
    refEl = document.querySelector(element)
  }

  if (!refEl || typeof refEl === 'string') {
    return
  }

  const el = document.getElementById('go-top')

  if ('IntersectionObserver' in window && el && refEl) {
    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            el.classList.remove('dca-go-top--hidden')
          } else {
            el.classList.add('dca-go-top--hidden')
          }
        })
      },
      {
        rootMargin: '0% 0% 0% 0%',
      }
    )

    observer.observe(refEl)
  }

  if (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault()

      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      } catch {
        /* istanbul ignore next */
        window.scrollTo(0, 0)
      }
    })
  }
}
